import { FormBuilder } from '@angular/forms';
import { HttpErrorsService } from '../services/utils/http-errors.service';
import { CustomNotificationService } from '../services/utils/custom-notification.service';
import {computed, Directive, OnInit, signal, Signal} from '@angular/core';
import { TableColumnModel } from '../models/table-column.model';
import { AResourceService } from '../services/resources/a-resource.service';
import { AModel } from '../models/resources/a-model';
import { finalize } from 'rxjs';
import {UrlParamModel} from "../models/url-param.model";

@Directive() // so that we can use ngOnInit
export abstract class AResourceTableComponent<M extends AModel> implements OnInit {
  models: Signal<M[]>;
  deleteLoadingIds = signal<number[]>([]);
  urlParams?: UrlParamModel[];

  abstract tableColumns: TableColumnModel[];

  protected constructor(
    protected formBuilder: FormBuilder,
    protected resourceService: AResourceService<M>,
    protected httpErrorsService: HttpErrorsService,
    protected notificationService: CustomNotificationService,
    protected resourceTranslation: string,
    protected paginated: boolean = true
  ) {
    this.models = computed(() => this.resourceService.models());
  }

  ngOnInit() {
    if (this.models().length === 0 || this.resourceService.apiResponse().filters) {
      this.resourceService.getAll({
        urlParams: [...this.urlParams ?? [], ...this.getStandardUrlParams()],
      });
    }
  }

  getStandardUrlParams(): UrlParamModel[] {
    return []
  }

  delete(id: number) {
    // add id to loading ids array
    this.deleteLoadingIds.update((ids) => {
      return [...ids, +id];
    });

    this.resourceService
      .delete(id)
      .pipe(
        finalize(() => {
          // remove id from loading ids array
          this.deleteLoadingIds.update((ids) => {
            return ids.filter((i) => i != id);
          });
        }),
      )
      .subscribe({
        next: () => {
          if(this.paginated)
            this.resourceService.getAll({
              urlParams: this.urlParams,
              lazyLoad: true,
            });
          this.notificationService.success(
            `${this.resourceTranslation}.SUCCESSFULLY_DELETED`,
          );
        },
        error: (e) => {
          this.httpErrorsService.handleError(e);
        },
      });
  }
}
